import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import { Tabs, Item as TabItem } from 'devextreme-react/tabs';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import { MultiView } from 'devextreme-react/multi-view';
import { LoadPanel } from 'devextreme-react/load-panel';
import AntCondition from '../utils/AntCondition';
import AntLocalization from '../utils/AntLocalization';
import AntAccordion from './AntAccordion';

export default function (props) {
    const [selectedTabIndex, setSelectedTabIndex] = useState(
        props.selectedTabIndex !== undefined ? props.selectedTabIndex : props.defaultSelectedIndex !== undefined ? props.defaultSelectedIndex : 0
    );

    const initTabs = useCallback(() => {
        var source = props.rawTabs instanceof Array ? props.rawTabs : [];
        var whitelist = props.tabs instanceof Array ? props.tabs : null;
        return source.filter((tab) => {
            if (whitelist && !whitelist.some((t) => t.name === tab.name)) return false;
            if (props.formData && !AntCondition.isVisible(props.formData, tab)) return false;
            return true;
        });
    }, [props.formData, props.tabs, props.rawTabs]);

    const mainTabs = useMemo(() => initTabs(), [initTabs, props.shouldRender]);

    // const handleTabChanged = (e) => {
    //     if (e.fullName === 'selectedIndex') {
    //         let tabIndex = e.value >= 0 ? e.value : 0;
    //         setSelectedTabIndex(tabIndex);
    //     }
    // };

    const handleAccordionChanged = useCallback(
        (e) => {
            if (e.addedItems.length > 0) {
                var selectedTabName = e.addedItems[e.addedItems.length - 1].name;

                let tabIndex = mainTabs.findIndex((t) => t.name === selectedTabName);
                if (tabIndex >= 0) setSelectedTabIndex(tabIndex);
            }
        },
        [mainTabs]
    );

    // const tabStyle = useMemo(() => {
    //     var style = props.tabStyle !== undefined ? props.tabStyle : 'COLLAPSE';
    //     if (!style) style = 'COLLAPSE';
    //     style = String(style).toUpperCase();
    //     return style;
    // }, [props.tabStyle]);

    // Báo cả khi danh sách tab đổi (tab ẩn/hiện theo dữ liệu): cùng một chỉ số có thể
    // trỏ sang tab khác, nơi nhận cần biết đúng tab đang mở.
    useEffect(() => {
        var tab = mainTabs[selectedTabIndex];
        var tabName = tab && tab.name ? tab.name : String(selectedTabIndex);
        if (props.onTabChanged) props.onTabChanged(tabName, selectedTabIndex);
    }, [selectedTabIndex, mainTabs]);

    const isVisible = props.visible !== undefined ? props.visible : true;
    const isMultipleTabs = isVisible && props.tabs instanceof Array && props.tabs.length > 1;
    if (!isVisible) return <React.Fragment> </React.Fragment>;

    // if (tabStyle === 'TAB' || !isMultipleTabs) {
    //     if (!isMultipleTabs && props.onRenderTabContent) {
    //         var tab = props.tabs[0];
    //         var tabName = tab && tab.name ? tab.name : String(0);
    //         return props.onRenderTabContent(tabName);
    //     } else
    //         return (
    //             <React.Fragment>
    //                 {isMultipleTabs && (
    //                     <Box shouldRender={props.shouldRender} direction="col" width="100%" height={'100%'}>
    //                         <BoxItem baseSize={40}>
    //                             <Tabs selectedIndex={selectedTabIndex !== undefined ? selectedTabIndex : 0} onOptionChanged={handleTabChanged}>
    //                                 {mainTabs.map((tab, i) => {
    //                                     var isHighlight = Boolean(
    //                                         props.highlightTabs instanceof Array ? props.highlightTabs.find((tab2) => tab2 === tab.name) : false
    //                                     );

    //                                     return (
    //                                         <TabItem key={tab.name ? tab.name : String(i)}>
    //                                             {isHighlight && (
    //                                                 <i
    //                                                     className={'ant-icon-warning dx-icon dx-icon-warning'}
    //                                                     style={{
    //                                                         marginRight: 9,
    //                                                         marginBottom: 4,
    //                                                         display: 'inline-block'
    //                                                     }}
    //                                                 ></i>
    //                                             )}
    //                                             <span>
    //                                                 {tab.caption
    //                                                     ? AntLocalization.translateText(tab.caption)
    //                                                     : tab.label
    //                                                     ? AntLocalization.translateText(tab.label)
    //                                                     : tab.name
    //                                                     ? tab.name
    //                                                     : ''}
    //                                             </span>
    //                                         </TabItem>
    //                                     );
    //                                 })}
    //                             </Tabs>
    //                         </BoxItem>
    //                         <BoxItem ratio={1}>
    //                             <MultiView
    //                                 height={'100%'}
    //                                 className="ant-tab-content-container"
    //                                 noDataText=""
    //                                 dataSource={mainTabs.map((tab, i) => {
    //                                     return tab.name ? tab.name : String(i);
    //                                 })}
    //                                 itemRender={props.onRenderTabContent}
    //                                 selectedIndex={selectedTabIndex !== undefined ? selectedTabIndex : 0}
    //                                 deferRendering={props.lazyLoading !== undefined ? props.lazyLoading : true}
    //                                 animationEnabled={false}
    //                                 swipeEnabled={false}
    //                             />
    //                         </BoxItem>
    //                     </Box>
    //                 )}
    //                 {!isMultipleTabs && (
    //                     <MultiView
    //                         height={'100%'}
    //                         shouldRender={props.shouldRender}
    //                         className="ant-tab-content-container-alone"
    //                         dataSource={mainTabs.map((tab, i) => {
    //                             return tab.name ? tab.name : String(i);
    //                         })}
    //                         noDataText=""
    //                         itemRender={props.onRenderTabContent}
    //                         selectedIndex={selectedTabIndex !== undefined ? selectedTabIndex : 0}
    //                         deferRendering={props.lazyLoading !== undefined ? props.lazyLoading : true}
    //                         animationEnabled={false}
    //                         swipeEnabled={false}
    //                     />
    //                 )}
    //             </React.Fragment>
    //         );
    // }

    // if (tabStyle === 'COLLAPSE')
    return (
        <React.Fragment>
            <AntAccordion
                shouldRender={props.shouldRender}
                isH5={props.isH5 !== undefined ? props.isH5 : true}
                isH4={props.isH4 !== undefined ? props.isH4 : false}
                isH6={props.isH6 !== undefined ? props.isH6 : false}
                showIndex={props.showIndex !== undefined ? props.showIndex : Boolean(mainTabs.length > 1)}
                selectedIndex={selectedTabIndex !== undefined ? selectedTabIndex : 0}
                dataSource={mainTabs}
                itemRender={props.onRenderTabContent}
                stableItems={props.stableItems}
                autoHideTitle={props.autoHideTitle}
                animationDuration={props.animationDuration}
                onSelectionChanged={handleAccordionChanged}
                deferRendering={props.lazyLoading !== undefined ? props.lazyLoading : false}
                collapsible={props.groupCollapsible !== undefined ? props.groupCollapsible : true}
                multiple={props.groupExpandMultiple !== undefined ? props.groupExpandMultiple : false}
                autoExpandAll={props.autoExpandAll !== undefined ? props.autoExpandAll : false}
            ></AntAccordion>
        </React.Fragment>
    );
}
